export const DOCUMENT_MIN_WIDTH = 760;
export const DOCUMENT_CHAT_MIN_WIDTH = 320;
export const DOCUMENT_CHAT_MAX_WIDTH = 560;
export const DOCUMENT_CHAT_DEFAULT_WIDTH = 360;

export function documentEditorLayout(
  width: number,
  preferredWidth: number,
  chatOpen: boolean,
) {
  const split =
    chatOpen && width >= DOCUMENT_MIN_WIDTH + DOCUMENT_CHAT_MIN_WIDTH;
  const maximum = Math.max(
    DOCUMENT_CHAT_MIN_WIDTH,
    Math.min(DOCUMENT_CHAT_MAX_WIDTH, width - DOCUMENT_MIN_WIDTH),
  );
  const chatWidth = Math.max(
    DOCUMENT_CHAT_MIN_WIDTH,
    Math.min(
      maximum,
      Number.isFinite(preferredWidth)
        ? preferredWidth
        : DOCUMENT_CHAT_DEFAULT_WIDTH,
    ),
  );
  return { split, chatOnly: chatOpen && !split, chatWidth, maximum };
}
